/* istanbul ignore file */
export enum NoticeSortField {
  Notice = "Title",
  Status = "Status",
  PublishDate = "PublishDate",
  Author = "Author"
}
